import $ from 'jquery';
import style from "./style";

//
//   Tooltips
//
//////////////////////////////////////////////////////////////////////

const _handleTooltipTouchstart = function (event) {
  if (this && $(this).parents('.list__tooltip').length > 0) {
    event.preventDefault();
  }

  let leftPos = '-25px';
  let rightPos = 'auto';

  if (this && $(this).parents('.l-post__next').length > 0) {
    leftPos = 'auto';
    rightPos = '-25px';
  }

  $('.js-tooltip-box').css({'opacity':0});
  $(this).find('.js-tooltip-box').css({'opacity':1,'top':'auto','bottom':'40px','left':leftPos,'right':rightPos,'marginLeft':0});
}

const _handleTooltipTouchend = function (event) {
  if (this && $(this).parents('.list__tooltip').length > 0) {
    event.preventDefault();
  }

  $('.js-tooltip-box').css({'opacity':0});
}

const _handleTooltipFocus = function (event) {
  _handleTooltipTouchstart.bind(this)(event)

  // When focusing, also elevate the z-index of the parent tier (if any);
  let $parentTier = $(this).parents('.l-pricing-row__col');
  if ($parentTier) {
    $parentTier.css({ 'z-index': '1000 !important' });
  }
}

const _handleTooltipBlur = function (event) {
  // _handleTooltipTouchend.bind(this)(event)

  // When bluring, also clear the customized z-index of the parent tier (if any);
  let $parentTier = $(this).parents('.l-pricing-row__col');
  if ($parentTier) {
    $parentTier.css({ 'z-index': null, });
  }
}

const tooltips = function() {
  const $tooltips = $(".js-tooltip");
  const $pricingCols = $('.l-pricing-row__col');
  
  $tooltips.on('touchstart', _handleTooltipTouchstart);
  $tooltips.on('touchend', _handleTooltipTouchend);

  // $tooltips.on('focus', _handleTooltipFocus);
  // $tooltips.on('blur', _handleTooltipBlur);

  // Hover
  $tooltips.mouseover(function(){
    // Position tooltip relative to mouse coordinates
    $(this).mousemove(function(e) {
      positionTooltip(e, this.querySelector('.js-tooltip-box'));
    });
  });
}

function positionTooltip(e, $box) {
  const $target = e.target;

  const targetRect = $target.getBoundingClientRect();
  const boxRect = $box.getBoundingClientRect();

  const localMouseX = e.offsetX;
  const localMouseY = e.offsetY;

  const wouldOverflowRight = e.pageX + $box.offsetWidth > window.innerWidth;
  const wouldOverflowLeft = e.pageX - $box.offsetWidth < 0;

  if (wouldOverflowRight && wouldOverflowLeft) {
    // Center it in the viewport.
    const boxLeft = (window.innerWidth - boxRect.width) / 2;

    style($box, {
      top: `${localMouseY - boxRect.height}px`,
      left: `${boxLeft - targetRect.left}px`,
    });
  } else if (wouldOverflowRight) {
    // Nudge the tooltip so it appears to be anchored at the bottom-right corner:
    style($box, {
      top: `${localMouseY - boxRect.height}px`,
      left: `${localMouseX - boxRect.width - 10}px`,
    });
  } else {
    // We have enough room here, so it can be anchored based on the bottom-left corner:
    style($box, {
      top: `${localMouseY - boxRect.height}px`,
      left: `${localMouseX + 10}px`,
    });
  }
}

export { tooltips, positionTooltip };
